<template>
  <div>
    <b-sidebar shadow="lg" v-model="show.form" right width="65%" bg-variant="white"
      title="Create Maintenance & Docking Plan" @toggle="show.form = !show.form">
      <template v-if="show.form">
        <FormMaintenanceDocking :selectedData="selectedData" @close="show.form = false" :optionsTaskType="optionsTaskType" @refetch="
          () => {
            show.form = false
            fetchData()
          }
        " />
      </template>
    </b-sidebar>
    <b-modal v-model="showModal" title="Import Data" ok-title="Submit" @ok="handleimportTargetAv"
      :loading="loadingImport">
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i class="fa fa-times cursor-pointer" @click="showModal = false"></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file v-model="importFile" type="file" class="form-control" accept=".xlsx, .xls, .csv" />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button v-if="!loadingExportTemplate" variant="outline-primary" class="mt-3 w-100"
          @click="handleExportTemplateAv">
          <i class="fa fa-download"></i> Download Template
        </b-button>
        <b-button v-else variant="outline-primary" class="mt-3 w-100">
          <b-spinner style="width: 18px; height: 18px;" class="mr-2"></b-spinner> Downloading
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showModalFilter" centered size="md" title="Filter Data" @ok="fetchData" ok-title="Filter">
      <b-row class="mb-2">
        <b-col md="4">
          <label class="b-label">Date</label>
        </b-col>
        <b-col md="8">
          <date-picker range v-model="dateRange" value-type="YYYY-MM-DD" format="DD-MM-YYYY" class="w-100" />
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4">
          <label class="b-label">Fleet Type</label>
        </b-col>
        <b-col md="8">
          <v-multiselect v-model="params.vehicle_type_ids" placeholder="Search Fleet Type" label="name"
            :options="optionsFleetTypes" :multiple="true" required track-by="id" class="mr-2">
            <span slot="noResult">Fleet type not found.</span>
          </v-multiselect>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4">
          <label class="b-label">Maintenance Type</label>
        </b-col>
        <b-col md="8">
          <v-multiselect :options="[
            { label: 'Docking', id: 'docking' },
            ...optionsTaskType,
          ]" v-model="params.maintenance_or_task_types" :multiple="true" label="label" track-by="id"></v-multiselect>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ok-only top v-model="show.remark" centered size="md" title="Remark" @ok="show.remark = false"
      ok-title="Close">
      <div class="d-flex flex-column">
        <div v-html="remark" class="text-black" ></div>
      </div>
    </b-modal>
    <div class="">
      <div class="d-flex justify-content-between align-items-center my-3">
        <div class="d-flex align-items-center">
          <b-button variant="outline-primary" class="mr-2 text-nowrap" @click="showModalFilter = true">
            <i class="fas fa-sliders"></i>
            Filter Data
          </b-button>
          <b-input @keyup="onSearchKeyup" v-model="params.search" class="mx-2" placeholder="Search..." />
        </div>
        <div md="3" class="d-flex justify-content-end align-items-center">
          <b-button :disabled="loadingExport" @click="handleExportTargetAv" variant="outline-primary"
            style="height: max-content;" class="text-truncate mr-2">
            <b-spinner style="width: 16px; height: 16px;" class="mr-1" v-if="loadingExport"></b-spinner> {{
              loadingExport ?
                'Loading...' : 'Export' }}
          </b-button>
          <b-dropdown id="dropdown-left" text="Create Data" variant="primary" class="m-2">
            <b-dropdown-item href="#" @click="show.form = true, selectedData = null">New Data</b-dropdown-item>
            <b-dropdown-item href="#" @click="showModal = true">Import Data</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <template v-if="!loading">
        <div class="overflow-auto relative w-100">
          <table class="w-100 striped-table">
            <thead>
              <th class="p-2">No</th>
              <th class="p-2">Fleet Name</th>
              <th class="p-2">Fleet Type</th>
              <!-- <th class="p-2">Group / PIC</th> -->
              <th class="p-2">Maintenance Type</th>
              <th class="p-2">Start Date</th>
              <th class="p-2">End Date</th>
              <th class="p-2">Duration</th>
              <th class="p-2">Remarks</th>
              <th class="p-2">Status</th>
              <th class="p-2 text-center">Actions</th>
            </thead>
            <tbody>
              <template v-if="listPlanAvailabilities?.length">
                <tr v-for="(item, index) in listPlanAvailabilities" :key="index">
                  <td class="p-2">{{ getRowNumber(index) }}</td>
                  <td class="p-2 text-truncate">{{ item?.vehicle?.name }}</td>
                  <td class="p-2 text-truncate">{{ item?.vehicle?.vehicle_type?.name }}</td>
                  <!-- <td class="p-2 text-truncate">{{ '-' }}</td> -->
                  <!-- <td class="p-2 text-truncate text-capitalize">{{ item?.maintenance_type?.replace(/_/g, ' ') }} {{
                    item?.task_type ? "- " + item?.task_type?.name : '' }}</td> -->
                  <td class="p-2 text-truncate">
                    <div :class="getColorType(item?.task_type ? item?.task_type?.alias : item?.maintenance_type)" class="text-capitalize px-2 font-semibold" style="border-radius: 4px; width: fit-content;">
                      {{ item?.task_type ? item?.task_type?.name : item?.maintenance_type?.replace(/_/g, ' ') }}
                    </div>
                  </td>
                  <td class="p-2 text-truncate">{{ moment(item?.start_date).format('DD MMM YYYY') }}</td>
                  <td class="p-2 text-truncate">{{ item?.end_date ? moment(item?.end_date).format('DD MMM YYYY') : '-' }}</td>
                  <td class="p-2 text-truncate">{{ moment(item?.end_date || new Date()).diff(item?.start_date, 'days') + 1 }} days</td>
                  <td class="p-2 text-truncate">
                    <b-button @click="show.remark = true, remark = item?.remark" variant="secondary" size="sm" >
                      Remark 
                    </b-button>
                  </td>
                  <td class="p-2 text-truncate">{{ getPreferredStatus(item) }}</td>
                  <td class="p-2 text-truncate">
                    <div class="d-flex justify-content-center">
                      <b-button  variant="outline-primary" class="mr-2" size="sm" @click="selectedData = item, show.form = true">
                        <i class="fa fa-edit" ></i>
                      </b-button>
                      <b-button  variant="outline-danger" size="sm" @click="handleDelete(item)">
                        <i class="fa fa-trash" ></i>
                      </b-button>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="17" class="col-1 sticky p-3">
                    No data here!
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="mt-4 d-flex align-items-center w-100 justify-content-end">
          <b-pagination class="mb-0 mr-3" @change="(page) => {
            meta.page = page
            fetchData()
          }" v-model="meta.page" :total-rows="meta.totalItems" :per-page="meta.perPage" first-number
            align="center"></b-pagination>
          <b-form-select plain v-model="meta.perPage" :options="limitOptions" style="width: 140px;"
            @input="() => {
              meta.page = 1
              fetchData()
            }"></b-form-select>
        </div>
      </template>
      <div v-else colspan="17" class="d-flex justify-content-center p-5 w-100">
        <b-spinner></b-spinner>
      </div>
    </div>
    <b-modal v-model="showErrImport" title="Import Error Information" ok-only >
      <div style="overflow: auto; max-height: 70vh;">
        <table class="w-100">
          <thead>
            <th class="p-2" style="width: 30%;">Row Number</th>
            <th class="p-2">Message</th>
          </thead>
          <tbody>
            <template v-if="msgErrImport.length">
              <tr v-for="(item, index) in msgErrImport" :key="index">
                <td class="p-2 px-4">{{ item.rowNumber }}</td>
                <td class="p-2">{{ item.message }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { srActions, fleetsActions } from '@/src/Utils/helper'
import moment from '@/node_modules/moment/moment'
import FormTargetFleetAvailability from '../FormTargetFleetAvailability.vue'
import FormMaintenanceDocking from '../FormMaintenanceDocking.vue'

export default {
  name: 'MaintenanceDocking',
  data() {
    return {
      _searchDebounceTimer: null,
      listPlanAvailabilities: [],
      show: {
        form: false,
        remark: false,
      },
      selectedData: null,
      showErrImport: false,
      dateRange: [
        moment().startOf('year').format('YYYY-MM-DD'),
        moment().endOf('year').format('YYYY-MM-DD')
      ],
      showModal: false,
      showModalFilter: false,
      maintenance_or_task_types: [],
      remark: '',
      loading: false,
      loadingExportTemplate: false,
      loadingImport: false,
      loadingExport: false,
      params: {
        year: moment().toDate(),
        search: '',
        vehicle_type_ids: [],
        maintenance_or_task_types: []
      },
      optionsFleetTypes: [],
      optionsTaskType: [],
      user_id: JSON.parse(localStorage.getItem('profile')).id,
      meta: {
        page: 1,
        perPage: 10,
        totalItems: 10,
        totalPage: 1,
      },
      limitOptions: [
        { value: 10, text: "10 / Page" },
        { value: 25, text: "25 / Page" },
        { value: 50, text: "50 / Page" },
      ],
      importFile: null,
      msgErrImport: []
    }
  },
  components: {
    FormTargetFleetAvailability,
    FormMaintenanceDocking,
  },
  methods: {
    ...srActions,
    ...fleetsActions,
    getPreferredStatus(item) {
      const logs = item?.status_logs || []
      if (!logs.length) return '-'
      // Prefer the last log with status === 'closed'
      const closedLogs = logs.filter(l => (l?.status || '').toLowerCase() === 'closed')
      if (closedLogs.length) return closedLogs[closedLogs.length - 1]?.status || '-'
      // Otherwise, pick the most recent by createdAt
      const sorted = [...logs].sort((a, b) => {
        const ta = new Date(a?.createdAt || a?.created_at || 0).getTime()
        const tb = new Date(b?.createdAt || b?.created_at || 0).getTime()
        return ta - tb
      })
      return sorted[sorted.length - 1]?.status || '-'
    },
    async getMasterTaskType() {
      try {
        let params = this.$options.filters.cleanObject({
          page: 1,
          perPage: 9999,
          showAll: true,
          active: true,
          search: '',
          user_id: this.user_id
        })
        const { data } = await this.fetchMasterTaskType(params)
        this.optionsTaskType = data.map((el) => ({
          label: el.name,
          id: el.id,
        }))
      } catch (error) {
        console.log(error)
      }
    },
    async fetchData() {
      try {
        this.loading = true
        const params = {
          user_id: this.user_id,
          ...this.meta
        }
        const body = {
          start_date: this.dateRange[0],
          end_date: this.dateRange[1],
          vehicle_type_ids: this.params?.vehicle_type_ids.map((val) => val.id),
          maintenance_or_task_types: this.params?.maintenance_or_task_types.map((val) => val.id),
          search: this.params.search
        }
        const { data } = await this.getTargetAvailabilityPlan({ params, body })
        this.listPlanAvailabilities = data.data
        this.meta.totalItems = data.meta.total_item
        this.meta.perPage = data.meta.per_page
        this.meta.totalPage = data.meta.total_pages
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getVehicleType() {
      this.optionsFleetTypes = []
      let { status, data } = await this.getFleetTypes()

      if (status === 'success') {
        this.optionsFleetTypes = data
      }
    },
    findMonth(data, month) {
      return data?.find((el) => el?.month == month)
    },
    getRowNumber(index) {
      return ((this.meta.page - 1) * this.meta.perPage) + (index + 1);
    },
    async handleExportTemplateAv() {
      try {
        this.loadingExportTemplate = true
        const params = {
          user_id: this.user_id,
        }
        const res = await this.getTemplateTargetAv(params)
        saveAs(res.data, 'TemplateImportMaintenanceDockingReport.xlsx')
        this.$swal({
          title: 'Import Data Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Failed Data Success',
          icon: 'error',
        })
      } finally {
        this.loadingExportTemplate = false
      }
    },
    async handleExportTargetAv() {
      console.log('HITTT')
      try {
        this.loadingExport = true
        const body = {
          start_date: this.dateRange[0],
          end_date: this.dateRange[1],
          vehicle_type_ids: this.params?.vehicle_type_ids.map((val) => val.id),
          maintenance_or_task_types: this.params?.maintenance_or_task_types.map((val) => val.id),
        }
        const params = {
          user_id: this.user_id,
          perPage: 9999,
        }
        // Use new docking-specific export endpoint
        const res = await this.$store.dispatch('sr/exportTargetAvailability', { body: { ...body, export_path: 'target-availabilities/docking/export' }, params })
        saveAs(res.data, `MaintenanceDockingReport_${moment().format('DDMMYYYY')}.xlsx`)
        this.$swal({
          title: 'Success Export Data',
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Failed Export Data',
          icon: 'error',
        })
      } finally {
        this.loadingExport = false
      }
    },
    async handleimportTargetAv() {
      try {
        this.loadingImport =
          this.msgErrImport = []
        const formData = new FormData()
        formData.append('file', this.importFile)
        const res = await this.importTargetAvailability({ body: formData, params: { user_id: this.user_id } })
        this.$swal({
          title: 'Import Data Success',
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        const message = error.data.data.rowCantInsert
        if (message?.length) {
          this.msgErrImport = message
        }
        this.$swal({
          title: "Failed Import Data!",
          type: 'error',
          text: 'Failed Import Data please check your file import!',
          icon: 'error',
          didClose: () => {
            this.showErrImport = true
          }

        })
      } finally {
        this.loadingImport = false
        this.fetchData()
      }
    },
    getColorType(type) {
      switch (type) {
        case 'docking':
          return 'bg-warning text-white'
        case 'planning_maintenance':
          return 'bg-primary text-white'
        case 'running_maintenance':
          return 'bg-success text-white'
        case 'repair_maintenance_breakdown':
          return 'bg-yellow-custom text-black'
        case 'emergency_breakdown':
          return 'bg-danger text-white'
        default:
          return 'bg-secondary text-white'
      }
    },
    handleDelete(item) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          try {
            const data = {target_availability_ids:[item.id]}
            await this.deleteTargetAvailability({ data })
            this.$swal('Success', 'Data has been deleted!', 'success')
            this.fetchData()
          } catch (error) {
            console.error(error)
            this.$swal('Error', 'Failed to delete data!', 'error')
          }
        }
      })
    },
    onSearchKeyup () {
      if (this._searchDebounceTimer) clearTimeout(this._searchDebounceTimer)
      this._searchDebounceTimer = setTimeout(() => {
        this.meta.page = 1
        this.fetchData()
      }, 400)
    }
  },
  mounted() {
    this.getMasterTaskType()
    this.fetchData()
    this.getVehicleType()
  },
}
</script>
<style scoped>
.bg-yellow-custom {
  background: #FDDA0D !important;
}
table td {
  color: #000 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.relative {
  position: relative;
}

.col-month {
  min-width: 160px;
}

.sticky {
  position: sticky !important;
}

.col-1 {
  left: 0px !important;
  z-index: 20;
  min-width: 40px;
}

.col-2 {
  left: 40px !important;
  z-index: 20;
  min-width: 200px;
  max-width: 200px;
}

.col-3 {
  left: 240px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}

.col-4 {
  left: 340px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}

.col-5 {
  left: 440px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
</style>
